/** @format */

import { Avatar, Box, ButtonBase, Stack, SvgIcon, Typography, useMediaQuery } from '@mui/material';
import User01Icon from '@untitled-ui/icons-react/build/esm/User01';
import { getTime } from 'date-fns';
import { get } from 'lodash';
import { userOptionRoles } from 'src/config';
import { useAuth } from 'src/hooks/use-auth';
import { usePopover } from 'src/hooks/use-popover';
import { AccountPopover } from './account-popover';

export const AccountButton = () => {
  const { user } = useAuth();
  const popover = usePopover();
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));

  const timeLoad = getTime(new Date());

  return user ? (
    <>
      <Stack direction="row" columnGap={0.5} alignItems="center">
        {mdUp && (
          <Stack
            alignItems="flex-end"
            rowGap={-1}
            sx={{
              ' .MuiTypography-root': {
                lineHeight: 1.25
              }
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#008df2' }}>
              {get(user, 'displayName', 'Người dùng')}
            </Typography>
            <Typography variant="caption" gutterBottom>
              {get(userOptionRoles, `${user.role}.text`)}
            </Typography>
          </Stack>
        )}

        <Box
          component={ButtonBase}
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          sx={{
            alignItems: 'center',
            display: 'flex',
            borderWidth: 2,
            borderStyle: 'solid',
            // borderColor: 'divider',
            height: mdUp ? 42 : 38,
            width: mdUp ? 42 : 38,
            borderRadius: '50%',
            borderColor: '#008df2',

            ' .MuiAvatar-root': {
              height: mdUp ? 40 : 36,
              width: mdUp ? 40 : 36
            }
          }}
        >
          <AvatarComponent avatar={user.avatar} timeLoad={timeLoad} />
        </Box>
      </Stack>

      <AccountPopover anchorEl={popover.anchorRef.current} onClose={popover.handleClose} open={popover.open} />
    </>
  ) : (
    <></>
  );
};

const AvatarComponent = ({ avatar, timeLoad }) => {
  return (
    <Avatar src={`${avatar}?time=${timeLoad}`}>
      <SvgIcon>
        <User01Icon />
      </SvgIcon>
    </Avatar>
  );
};
